import * as React from 'react';
import { Box } from '@mui/system';
import { TopBar } from '../../components';
import { Divider } from '@mui/material';

interface ILayoutMainProps {
    children?: React.ReactNode;
    title: string;
}

export const LayoutMain: React.FC<ILayoutMainProps> = ({ children, title }) => {

    return (
        <React.Fragment>
            <Box display='flex' flexDirection='column' gap={2} >
                <Box display='flex' flexDirection='row' pt={3} >
                    <TopBar
                        title={title}
                    />
                </Box>
                <Divider />
                <Box flex={1} flexDirection='column' gap={2} >
                    {children}
                </Box>
            </Box>
        </React.Fragment >
    );
};

